import { CreditCardCriteria } from '@nemuru-eng/js-api-client';
import { generatePath, Link } from 'react-router-dom';

import { DETAILS_PATH_BY_PRODUCT } from '@/config/config';
import { ApplicationType } from '@/config/types';
import { useOperationsContext } from '@/contexts/OperationsContext/OperationsContext';
import { useCustomTheme } from '@/hooks/useCustomTheme';

export const toCreditCardDetailFieldColumn = ({ flex }: { flex?: number }) => {
  const { palette, customBorderRadius } = useCustomTheme();
  const {
    actions: { updateOperationsContext },
  } = useOperationsContext();

  return {
    flex: flex ?? 0.15,
    field: 'to_detail',
    sortable: false,
    headerName: ' ',
    disableOnRowClick: true,
    renderCell: (rowData: { row: CreditCardCriteria }) => {
      const targetPath = rowData.row.isLoan
        ? DETAILS_PATH_BY_PRODUCT[ApplicationType.CONSUMER_LOAN]
        : DETAILS_PATH_BY_PRODUCT[ApplicationType.CARD];

      const linkTo = (id: string) =>
        generatePath(targetPath, rowData.row.isLoan ? { loanId: id } : { creditCardId: id });

      return (
        <Link
          onClick={() => {
            if (!rowData?.row.isLoan) {
              return;
            }
            updateOperationsContext({ lastViewedLoanId: rowData?.row.id });
          }}
          to={linkTo(rowData?.row.id)}
          style={{
            minWidth: '40px',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            paddingLeft: '0px',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: palette.grey[100],
              width: 24,
              height: 24,
              borderRadius: customBorderRadius.button,
            }}
          >
            <i
              className="material-icons-outlined"
              style={{
                verticalAlign: 'sub',
                fontSize: '20px',
                color: palette.text.primary,
              }}
            >
              {'chevron_right'}
            </i>
          </div>
        </Link>
      );
    },
  };
};
